import { Component, OnDestroy, OnInit, ViewChild, inject, signal } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { DialogService } from '@next/core-lib/dialog';
import { ExportFormat } from '@next/core-lib/export';
import { ExportOptionsV2 } from '@next/core-lib/table-v2';
import { SelectedCustomer, UserSelectors } from '@next/core-lib/user';
import { Store, select } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';

import { DataSourceService } from '../../datasource/datasource.service';
import {
  OfferOverviewModel,
  OffersColumnTypes,
  offerDisplayColumns,
} from '../../models/overview.model';
import { openOfferOverviewDialog } from '../../store/actions/overview.actions';
@Component({
  selector: 'app-offer-overview-table',
  templateUrl: './offer-overview-table.component.html',
  styleUrls: ['./offer-overview-table.component.scss'],
  providers: [DialogService],
  standalone: false,
})
export class OfferOverviewTableComponent implements OnInit, OnDestroy {
  private readonly dataSourceService = inject(DataSourceService);
  private readonly store = inject(Store);

  readonly dataSource = this.dataSourceService.offerDataSource;
  displayColumns = signal<OffersColumnTypes[]>([...offerDisplayColumns]);
  selectedCustomer$: Observable<SelectedCustomer> = this.store.pipe(
    select(UserSelectors.selectCustomer),
  );
  readonly destroy$ = new Subject<void>();
  selectedCustomerId = signal<number | undefined>(undefined);
  isGlobalAdministrator = signal(false);
  isCustomer = signal(false);

  exportOptions: ExportOptionsV2 = {
    formats: [
      {
        format: ExportFormat.xlsx,
        name: 'XLSX',
      },
    ],
    fileName: 'mestplace_offers_export_' + new Date().toLocaleDateString(),
  };

  @ViewChild(MatTableDataSource) tableDataSource: MatTableDataSource<OfferOverviewModel[]>;
  ngOnInit(): void {
    this.selectedCustomer$.pipe(takeUntil(this.destroy$)).subscribe((customer) => {
      if (customer) {
        this.selectedCustomerId.set(customer.id);
      }
    });

    this.store
      .select(AuthorizationSelectors.hasGlobalAdministratorRoleForApplicationKey('Mestplace'))
      .pipe(takeUntil(this.destroy$))
      .subscribe((hasGlobalAdministratorRole) => {
        this.isGlobalAdministrator.set(hasGlobalAdministratorRole);

        if (hasGlobalAdministratorRole) {
          this.displayColumns.set([
            OffersColumnTypes.customerName,
            OffersColumnTypes.shipToAddress,
            OffersColumnTypes.contactInformation,
            ...offerDisplayColumns,
          ]);
        }
      });

    this.store
      .select(AuthorizationSelectors.hasCustomerRoleForApplicationKey('Mestplace'))
      .pipe(takeUntil(this.destroy$))
      .subscribe((hasAdvisorRole) => {
        this.isCustomer.set(hasAdvisorRole);
      });
  }

  openOfferOverviewDialog(selectedOffer: OfferOverviewModel) {
    this.store.dispatch(openOfferOverviewDialog({ selectedOffer }));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
